import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import rightShadow from "../../assets/images/heartShadowRight.png";
import leftShadow from "../../assets/images/heartShadowLeft.png";
import { getParentCategory } from "../../helper/backend-methods";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const CustomLeftArrow = ({ onClick }) => {
  return (
    <button className="custom-arrow left" onClick={onClick} aria-label="Previous">
      <i className="ri-arrow-left-line"></i>
    </button>
  );
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <button className="custom-arrow right" onClick={onClick} aria-label="Next">
      <i className="ri-arrow-right-line"></i>
    </button>
  );
};

const HeartOfTown = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

   const navigate = useNavigate();

  const getParentCategories = () => {
    setLoading(true);
    getParentCategory()
      .then(({ data }) => {
        if (data.Status) {
          setCategories(data.Data);
        }
      })
      .catch((err) => {
        setCategories([]);
        console.error("Error fetching categories:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1390 }, items: 6 },
    tablet: { breakpoint: { max: 1390, min: 710 }, items: 4 },
    mobile: { breakpoint: { max: 710, min: 450 }, items: 3 },
    mobileMini: { breakpoint: { max: 450, min: 0 }, items: 2 },
  };

  useEffect(() => {
    getParentCategories();
  }, []);

  return (
    <section id="heart-town">
      <div className="wrapper">
        <h2>FLAVOR FROM THE HEART OF TOWN</h2>

        <div className="heart-container">
          <img src={rightShadow} className="shadow-show shadow-right"/>
          <img src={leftShadow} className="shadow-show shadow-left"/>
          {!loading && categories.length === 0 ? (
            <p className="section-empty-message">No categories available right now.</p>
          ) : (
            <Carousel responsive={responsive} infinite arrows customLeftArrow={<CustomLeftArrow />} customRightArrow={<CustomRightArrow />}>
              {categories.map((item, index) => (
                <Link to={`/menu?categoryId=${item.CategoryId}`} key={index} className="heart-item-link">
                  <div className="heart-item">
                    <img src={item.CategoryPicture.Url} alt={item.CategoryName} className="hrtImg" />
                    <p className="ht-desc">{item.CategoryName}</p>
                  </div>
                </Link>
              ))}
            </Carousel>
          )}
        </div>

         <button className="view-menu" onClick={() => navigate("/menu")}>
          VIEW MENU
        </button>
      </div>
    </section>
  );
};

export default HeartOfTown;
